import styled from "styled-components";
import { theme } from "@ifgengineering/component-library";
import { ColorType } from "@styles/theme";

export const DealCardWrapper = styled.div`
  cursor: pointer;
  position: relative;
`;

export const StyledLogo = styled.img`
  width: 144px;
  min-width: 144px;
  border-radius: 2px;
  object-fit: contain;
`;

export const LogoTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: flex-start;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-top: 24px;
  gap: 24px;
`;

export const TagContainer = styled.div`
  position: relative;
  right: -19px;
  top: -19px;
  margin-bottom: -19px;
`;

export const DynamicTag = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ChildrenWrapper = styled.div`
  position: relative;
  padding: 7px;
`;

export const TitleDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TextContainer = styled.div<{
  background?: ColorType;
}>`
  display: flex;
  border-radius: 8px;
  flex-direction: row;
  align-items: center;

  background-color: ${({ background }) =>
    background ? theme.colors[background] : theme.colors.SLATE100};
  padding: 16px;
  gap: 8px;
`;

export const DealType = styled.div<{
  background: ColorType;
}>`
  position: absolute;
  background-color: ${({ background }) =>
    theme.colors[background] || theme.colors.SLATE100};
  border-radius: 8px 24px 24px 0;
  padding: 4px 16px 4px 16px;
  display: inline-block;
  left: 0;
  top: 0;
`;

export const ExpiredChildrenWrapper = styled.div`
  position: relative;
  padding: 7px;
  margin-top: 20px;
`;

export const DateContainer = styled.div`
  margin-top: 19px;
`;

export const LaunchDate = styled.div`
  width: fit-content;
  background-color: ${theme.colors.GOLD200};
  padding: 4px 16px;
  border-radius: 7px 16px 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PrelaunchChildrenWrapper = styled.div`
  position: relative;
  padding: 25px;
`;
